import { matchesMimeType } from 'oas/utils';

function getQuerystring(har) {
  const params = new URLSearchParams();
  (har.log.entries[0].request.queryString || []).forEach(qs => {
    params.append(qs.name, qs.value);
  });

  const queryString = params.toString();
  return queryString.length ? `?${queryString}` : '';
}

async function getResponseBody(response) {
  const contentType = response.headers.get('Content-Type');
  const isJson = contentType && (matchesMimeType.json(contentType) || matchesMimeType.wildcard(contentType));

  // We have to clone it before reading, just incase we cannot parse it as JSON later, then we can re-read again as
  // plain text
  const clonedResponse = response.clone();
  let responseBody;

  try {
    responseBody = await response[isJson ? 'json' : 'text']();
    if (isJson && typeof responseBody === 'object') responseBody = JSON.stringify(responseBody, null, 2);
  } catch (e) {
    responseBody = await clonedResponse.text();
  }

  return responseBody;
}

function getRequestBody(har) {
  let requestBody;

  try {
    requestBody = har.log.entries[0].request.postData.text || null;
  } catch (e) {
    requestBody = null;
  }

  return requestBody;
}

export default async function parseResponse(har, response) {
  const contentDisposition = response.headers.get('Content-Disposition');
  const querystring = getQuerystring(har);
  const responseHeaders = Array.from(response.headers.entries());
  const type = responseHeaders.find(([header]) => header === 'content-type');

  return {
    isBinary: !!(contentDisposition && contentDisposition.match(/attachment/)),
    method: har.log.entries[0].request.method,
    status: response.status,
    statusText: response.statusText,

    requestBody: getRequestBody(har),
    requestHeaders: har.log.entries[0].request.headers.map(header => `${header.name}: ${header.value}`),

    responseBody: await getResponseBody(response),
    responseHeaders: responseHeaders
      .map(header => {
        return {
          name: header[0],
          value: header[1],
        };
      })
      .filter(header => !header.name.match(/x-final-url/i)),

    timestamp: new Date().toISOString(),
    type: type ? type[1] : null,
    url: har.log.entries[0].request.url.replace('https://try.readme.io/', '') + querystring,
  };
}
